import React from 'react';
import './moodmate-visual.css';

/**
 * AmbientBackground — the layered, moving environment behind a MoodMate screen.
 *
 * Several depths stacked for a real sense of space: slow rotating light rays at
 * the back, drifting gradient orbs, two morphing blobs, and flowing waves at the
 * base. The blobs and rays read a parent's --mm-px / --mm-py (set by
 * usePointerParallax) to drift gently with the pointer on desktop. Decorative
 * only (aria-hidden, pointer-events: none); all motion stops under
 * prefers-reduced-motion.
 */
export const AmbientBackground: React.FC<{ className?: string; tinted?: boolean; waves?: boolean }> = ({
  className = '',
  tinted = true,
  waves = true,
}) => (
  <div className={`mm-ambient ${className}`} aria-hidden="true">
    <div className="mm-ambient__rays" />
    <span className="mm-ambient__orb mm-ambient__orb--1" />
    <span className="mm-ambient__orb mm-ambient__orb--2" />
    <span className="mm-ambient__orb mm-ambient__orb--3" />
    <span className="mm-ambient__orb mm-ambient__orb--4" />
    {tinted && <span className="mm-ambient__orb mm-ambient__orb--2 mm-ambient__orb--tint" />}
    <div className="mm-ambient__blob mm-ambient__blob--a" />
    <div className="mm-ambient__blob mm-ambient__blob--b" />
    {waves && (
      <svg className="mm-ambient__waves" viewBox="0 0 1200 240" preserveAspectRatio="none">
        <path
          className="mm-ambient__wave"
          fill="var(--mood-accent, #3fb9a0)"
          fillOpacity="0.14"
          d="M0 120 q 150 -50 300 0 t 300 0 t 300 0 t 300 0 V240 H0 Z"
        />
        <path
          className="mm-ambient__wave mm-ambient__wave--2"
          fill="var(--mood-soft, #bfe9f5)"
          fillOpacity="0.5"
          d="M0 160 q 150 -40 300 0 t 300 0 t 300 0 t 300 0 V240 H0 Z"
        />
      </svg>
    )}
  </div>
);

export default AmbientBackground;
